module.exports = __webpack_public_path__ + "img/done.ee8c2768.png";